<template>
  <div id="app">
    <div class="header add-fixed">
      <div class="logo_img" @click="logoClick">
        <div style="display:flex; align-items: center;justify-content: center; float:left; height: 65px;">
          <div class="header-logo">
            <img id="header-img" src="../assets/legu/logo.png" />
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu v-if="seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
          style="height: 100%; border:0;" mode="horizontal" @select="handleSelectMenu">
          <el-menu-item class="item-menu" index="1">{{ $t('title1') }}</el-menu-item>
          <el-menu-item class="item-menu" index="3">{{ $t('title2') }}</el-menu-item>
          <el-menu-item class="item-menu" index="5">{{ $t('title3') }}</el-menu-item>
          <el-menu-item class="item-menu">
            <el-dropdown @command="changeLangEvent"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">
              <span class="el-dropdown-link" style="display: inline-flex; height: 100%; align-items: center;">
                {{ $t('languageText') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="ZH">简体中文</el-dropdown-item>
                <el-dropdown-item command="EN">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>
        </el-menu>
        <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
        <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
          style="height: 54px; border:0;" @select="handleSelectMenu" mode="horizontal">
          <el-menu-item>
            <el-dropdown size="small" @command="handleSelectMenu" trigger="click"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">

              <span class="el-dropdown-link"
                style="display: inline-flex; height: 100%; align-items: center; font-size: 12px;">
                {{ $t('home') }}<i style="font-size: 12px;" class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">{{ $t('title1') }}</el-dropdown-item>
                <el-dropdown-item command="3">{{ $t('title2') }}</el-dropdown-item>
                <el-dropdown-item command="5">{{ $t('title3') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>

          <el-menu-item>
            <el-dropdown size="small" @command="changeLangEvent" trigger="click"
              style="display: inline-flex; align-items: flex-start; height: 100%; font-size: 16px; color: rgb(51, 51, 51);">

              <span class="el-dropdown-link" style="display: inline-flex; height: 100%; align-items: center;">
                <!-- {{ $t('languageText') }} -->
                <i style="font-size: 12px;" class="el-icon-menu el-icon--right"></i>
                <i style="font-size: 12px;" class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="ZH">简体中文</el-dropdown-item>
                <el-dropdown-item command="EN">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item>

        </el-menu>
      </div>
    </div>

    <div style="padding-top: 54px;">
      <router-view></router-view>
    </div>

    <div id="ContactUs" class="footerCopyRight pt-3 pb-6">
      <div class="mt-6 mb-3 text-center font-bold" style="font-size: 34px;">
        {{ $t('title3') }}
        <br>
      </div>
      <div class="text-center footer-text">
        <span class="font-bold">{{ $t('infoTitle1') }}</span>： {{ $t('infoDesc1') }}
      </div>
      <div class="text-center mt-3 footer-text">
        <span class="font-bold">{{ $t('infoTitle2') }}</span>： {{ $t('infoDesc2') }}
      </div>

      <div style="width: 100%; margin: 20px auto; ">
        <div style="text-align: center;font-size: 0.1em;"><a href="http://beian.miit.gov.cn" target="_blank"
            style="color:#000">
            {{ $t('infoDesc3') }} | {{ $t('infoDesc4') }}</a>
        </div>
      </div>

      <div class="bottom-info">
        <a style="margin-right: 16px; font-weight: bold;" href="/policy.html" target="_blank">{{ $t('infoDesc5') }}</a>
        <a style="font-weight: bold;" href="/service.html" target="_blank">{{ $t('infoDesc6') }}</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      activeIndex: '1',
      seen: true,
    };
  },

  mounted() {
    this.menuSeen();
    const debouncedResize = this.debounce(this.menuSeen, 200);
    window.addEventListener('resize', debouncedResize);
  },

  methods: {
    debounce(func, delay) {
      let timer;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    },
    changeLangEvent(lan) {
      if (lan == 'ZH' || lan == 'zh') {
        localStorage.setItem('locale', 'zh');
        this.$i18n.locale = localStorage.getItem('locale');
        localStorage.setItem('lang', 'ZH');
        this.language = 'ZH';
        // location.reload(); //重新加载
      } else if (lan == 'EN' || lan == 'en') {
        localStorage.setItem('locale', 'en');
        this.$i18n.locale = localStorage.getItem('locale');
        localStorage.setItem('lang', 'EN');
        this.language = 'EN';
        // location.reload();
      }
    },
    handleSelectMenu(key) {
      switch (key) {
        case '1':
          window.location.hash = '#AboutUs';
          break;
        case '3':
          window.location.hash = '#Products';
          break;
        case '5':
          window.location.hash = '#ContactUs';
          break;
      }
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 765) {
        // if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      this.$router.push({ name: 'Index' });
    }
  },
};
</script>

<style scoped>
@import '../assets/css/main.css';

.bottom-info {
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 14px;
  text-wrap: nowrap;
  color: black;
}


.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #ff6b11 !important;
}

.logo_img {
  display: flex;
  height: auto;
  align-items: center;
}


.el-menu-item {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 1em;
  font-size: 16px;
  font-weight: bold;
}


#menu_index {
  height: 100%;
}

.header {
  margin: 0 auto;
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
}

@media screen and (max-device-width: 415px) {
  .el-icon-menu {
    background: url('../assets/legu/icon-i18n.png') center center no-repeat;
    background-size: 14px;
  }

  .el-icon-menu::before {
    content: '11';
    visibility: hidden;
  }

  .header {
    display: flex;
    justify-content: center;
  }

  .logo_img {
    cursor: pointer;
    width: 40%;
    margin: 0 auto;
  }

  #menu_index {
    width: auto;
    height: 100%;
  }

  .footer {
    font-size: 0.1em;
    text-align: center;
    justify-content: space-between;
  }

  .footer span {
    width: 33%;
  }

  .footer-text {
    font-size: 12px;
  }
}

#header-img {
  width: 250px;
  float: left;
  margin: auto;
  cursor: pointer;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

.footerCopyRight {
  background: #ebeced66;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 376px) {
  .logo_img {
    width: 35%;
  }
}
</style>
